import { render, staticRenderFns } from "./titleBackground.vue?vue&type=template&id=33dafa58&scoped=true&"
import script from "./titleBackground.vue?vue&type=script&lang=js&"
export * from "./titleBackground.vue?vue&type=script&lang=js&"
import style0 from "./titleBackground.vue?vue&type=style&index=0&id=33dafa58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dafa58",
  null
  
)

export default component.exports